var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilterFlight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5784_26359)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21 1.23047C21 1.91011 20.4492 2.46094 19.7695 2.46094C19.0899 2.46094 18.5391 1.91011 18.5391 1.23047C18.5391 0.550827 19.0899 0 19.7695 0C20.4492 0 21 0.550827 21 1.23047ZM1.23047 18.5391C0.550827 18.5391 0 19.0899 0 19.7695C0 20.4492 0.550827 21 1.23047 21C1.91011 21 2.46094 20.4492 2.46094 19.7695C2.46094 19.0899 1.91011 18.5391 1.23047 18.5391ZM3.6916 18.5C3.98594 18.5 4.28051 18.3879 4.50475 18.163C4.95413 17.7136 4.95413 16.9856 4.50475 16.5362C4.0556 16.087 3.32738 16.087 2.87822 16.5362C2.42884 16.9856 2.42884 17.7136 2.87822 18.163C3.10246 18.3879 3.39703 18.5 3.6916 18.5Z",
    fill: "#192227"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7589 5.75806L14.2884 4.22178C14.9941 3.51084 17.0489 2.53684 17.7542 3.24777C18.4599 3.95871 17.4922 6.02773 16.7865 6.73867L15.2393 8.29726L16.2447 17.2352L14.5268 18.9664L11.9622 11.5993L7.9221 15.6421V18.3497L7.24205 19L5.453 15.6637L2 13.8402L2.73683 13.1264H5.4792L9.46595 9.09306L2.14943 6.49634L3.86859 4.76614L12.7589 5.75806Z",
    stroke: "#192227",
    strokeWidth: 1.575
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5784_26359"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterFlight);
export default __webpack_public_path__ + "static/media/FilterFlight.59943778340c3e31fca79fc1e5645ae3.svg";
export { ForwardRef as ReactComponent };